// extracted by mini-css-extract-plugin
export var container = "_48-1";
export var cornerButtonContainer = "_48-5";
export var disabled = "_48-2";
export var fileContainer = "_48-4";
export var hiddenInput = "_48-3";
export var widthContainer = "_48-0";